import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 9l3 3l-3 3","key":"svg-0"}],["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-1"}]]

const IconSquareChevronRight = createReactComponent('outline', 'square-chevron-right', 'SquareChevronRight', __iconNode);

export default IconSquareChevronRight;